// Read the former double envelope without rewriting historical draft rows.
export function bookingDraft(value) {
  let draft=value;
  for(let depth=0;depth<3 && draft && !draft.taskData && draft.data && typeof draft.data==='object';depth++) draft=draft.data;
  return draft && typeof draft==='object' && draft.taskData ? draft : null;
}
